<template>
    <x-page title="Report Statistik">
        <template #header-actions>
            <x-back-button
                :disabled="isLoading"
                :display-warning="false"
                :click-handler="handleBackButtonClick"
            />
        </template>

        <x-form-group label="Template" :horizontal="false">
            <x-input-group-statistic-template
                :allow-empty="false"
                v-model="selectedTemplate"
            />
        </x-form-group>

        <div class="row">
            <div class="col-xs-12 col-md-4 col-md-offset-4">
                <canvas :id="`pie-chart`"></canvas>
            </div>
        </div>
    </x-page>
</template>

<script>
import Chart from "chart.js/auto";
import { get } from "lodash";
import XAjaxDropdown from "../../../components/XAjaxDropdown.vue";
import XBackButton from "../../../components/XBackButton.vue";
import XFilterBox from "../../../components/XFilterBox.vue";
import XFormGroup from "../../../components/XFormGroup.vue";
import XInputMetrics from "../../../components/XInputMetrics.vue";
import XPage from "../../../components/XPage.vue";
import XPagination from "../../../components/XPagination.vue";
import XTable from "../../../components/XTable.vue";
import { emptyPromise, handleGeneralXhrError } from "../../../helpers";
import FilterableMixin from "../../../mixins/FilterableMixin";
import PaginationMixin from "../../../mixins/PaginationMixin";
import PermissionMixin from "../../../mixins/PermissionMixin";
import XDumbPagination from "../../../components/XDumbPagination.vue";
import XPanel from "../../../components/XPanel.vue";
import XInputGroupStatisticTemplate from "../../../components/XInputGroupStatisticTemplate.vue";
import XHelpDefault from "../../../components/XHelpDefault.vue";

let pieChart = null;

export default {
    beforeRouteUpdate(to, from, next) {
        this.fetchResources(to);
        next();
    },
    components: {
        XTable,
        XPage,
        XFormGroup,
        XFilterBox,
        XAjaxDropdown,
        XPagination,
        XBackButton,
        XInputMetrics,
        XDumbPagination,
        XPanel,
        XInputGroupStatisticTemplate,
        XHelpDefault,
    },
    created() {
        this.fetchReport();
    },
    data() {
        return {
            isLoading: false,
            metrics: [],
            selectedTemplate: null,
        };
    },
    methods: {
        fetchReport() {
            this.isLoading = true;

            if (!this.selectedTemplate) {
                return emptyPromise().finally(() => {
                    this.isLoading = false;
                });
            }

            const request = axios
                .get(
                    `/api/reports/group-statistics/${this.selectedTemplate.id}`
                )
                .then((response) => {
                    this.metrics = response.data.data;
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
        handleBackButtonClick(router) {
            router.replace("/admin/reports");
        },
        initPieChart() {
            const ctx = document.getElementById(`pie-chart`);
            pieChart = new Chart(ctx, {
                type: "doughnut",
                data: {
                    labels: get(this.selectedTemplate, "metrics", []).map(
                        (metric) => metric.label
                    ),
                    datasets: [],
                },
            });
            updatePieChart(pieChart, this.metrics);
        },
        updatePieChart() {
            updatePieChart(pieChart, this.metrics);
        },
    },
    mixins: [FilterableMixin, PaginationMixin, PermissionMixin],
    mounted() {
        this.initPieChart();
    },
    watch: {
        selectedTemplate: {
            handler() {
                this.fetchReport().then(() => {
                    this.updatePieChart();
                });
            },
            deep: true,
        },
    },
};

function updatePieChart(chart, metrics) {
    let colors = metrics.map((metric, index) => {
        const oldColor = get(chart, `data.datasets.backgroundColor.${index}`);
        return (
            oldColor || `#${Math.floor(Math.random() * 16777215).toString(16)}`
        );
    });

    chart.data.labels = metrics.map((metric) => metric.label);
    chart.data.datasets = [
        {
            data: metrics.map((metric) => parseInt(get(metric, "value", 0))),
            backgroundColor: colors,
            hoverOffset: 4,
        },
    ];
    chart.update();
}
</script>
